import React from 'react';
import { composeLyrics } from '../mvData';

export default function LyricsEditor({ sections, isEditing, onChange, onCopy, onToggleEdit, onRegenerate, cost, t }) {
  const updateLine = (sectionIndex, lineIndex, value) => {
    const next = sections.map((section, idx) => (
      idx === sectionIndex
        ? { ...section, lines: section.lines.map((line, i) => (i === lineIndex ? value : line)) }
        : section
    ));
    onChange(next);
  };
  const insertLine = (sectionIndex, lineIndex) => {
    const next = sections.map((section, idx) => {
      if (idx !== sectionIndex) return section;
      const lines = [...section.lines];
      lines.splice(lineIndex + 1, 0, '');
      return { ...section, lines };
    });
    onChange(next);
  };
  const deleteLine = (sectionIndex, lineIndex) => {
    const next = sections.map((section, idx) => {
      if (idx !== sectionIndex || section.lines.length <= 1) return section;
      return { ...section, lines: section.lines.filter((_, i) => i !== lineIndex) };
    });
    onChange(next);
  };

  return (
    <div className="mv-lyrics">
      <div className="mv-result__bar">
        <div><strong>{t('videoGeneration.mv.preview.lyricsTitle')}</strong><span>{t('videoGeneration.mv.preview.lyricsHint')}</span></div>
        <div className="mv-actions">
          <button onClick={onRegenerate}>{t('videoGeneration.mv.actions.regenerateWithCredits', { count: cost })}</button>
          <button onClick={() => onCopy(composeLyrics(sections))}>{t('videoGeneration.mv.actions.copy')}</button>
          <button onClick={onToggleEdit}>{t(`videoGeneration.mv.actions.${isEditing ? 'save' : 'edit'}`)}</button>
        </div>
      </div>
      {sections.map((section, sectionIndex) => (
        <div className="mv-lyrics__section" key={sectionKey(section, sectionIndex)}>
          <h4>{section.title}</h4>
          {section.lines.map((line, lineIndex) => (
            <div className="mv-lyrics__line" key={lineKey(section, sectionIndex, lineIndex)}>
              <input readOnly={!isEditing} value={line} onChange={(e) => updateLine(sectionIndex, lineIndex, e.target.value)} />
              {isEditing && <button onClick={() => insertLine(sectionIndex, lineIndex)}>+</button>}
              {isEditing && <button disabled={section.lines.length <= 1} onClick={() => deleteLine(sectionIndex, lineIndex)}>×</button>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

function sectionKey(section, index) {
  return `${section.title || 'section'}-${index}`;
}

function lineKey(section, sectionIndex, lineIndex) {
  return `${section.title || 'section'}-${sectionIndex}-${lineIndex}`;
}
